import React, { useState, useRef, useEffect } from 'react';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Link } from 'react-router-dom';

const ItemType = 'LIST_ITEM';

const DraggableItem = ({ id, name, index, moveItem, sequence }) => {
    const ref = useRef(null);
    const [, drag] = useDrag({
        type: ItemType,
        item: { id, index },
    });

    // Set up drop target
    const [, drop] = useDrop({
        accept: ItemType,
        hover(item) {
            if (item.index === index) return;

            moveItem(item.index, index);
            item.index = index;  // update the dragged item's index
        },
    });
    drag(drop(ref));
    return (
        <tr key={id} ref={ref} style={{ cursor: "grab" }}>
            <td>{index + 1}</td>
            <td>{sequence}</td>
            <td>{name}</td>
        </tr>
    );
};

const ReorderList = () => {
    const BASE_URL = process.env.REACT_APP_PP_URL;
    const [data, setData] = useState([]);
    const [filterData, setFilterData] = useState([...data]);

    const getList = async (url) => {
        const token = sessionStorage.getItem('tokenKey');
        try {
            if (url === "/admin/v1/category/parent-category-list-in-key-value") {
                const res = await fetch(`${BASE_URL}/admin/v1/category/parent-category-sequence-detail`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })
                const getRes = await res.json();
                if (getRes.errorCode === 0) {
                    setData(() => getRes.responsePacket?.slice().sort((a, b) => Number(a.sequenceNo) - Number(b.sequenceNo))?.map((itm) => ({
                        label: itm.title,
                        key: itm.uuid,
                        value: itm.uuid,
                        sequenceNo: itm.sequenceNo,
                    })) || []);
                    setFilterData(() => getRes.responsePacket?.slice().sort((a, b) => Number(a.sequenceNo) - Number(b.sequenceNo))?.map((itm) => ({
                        label: itm.title,
                        key: itm.uuid,
                        value: itm.uuid,
                        sequenceNo: itm.sequenceNo,
                    })) || []);
                }
            } else if (url === "/admin/v1/banner/list") {
                const res = await fetch(`${BASE_URL}/admin/v1/banner/list-data/Active`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    }
                });
                const getRes = await res.json();
                if (getRes.errorCode === 0) {
                    setData(() => getRes.responsePacket?.slice()?.sort((a, b) => Number(a.sequenceNo) - Number(b.sequenceNo)).map((itm) => ({
                        label: itm.title,
                        key: itm.uuid,
                        value: itm.uuid,
                        sequenceNo: itm.sequenceNo,
                    })) || []);
                    setFilterData(() => getRes.responsePacket?.slice().sort((a, b) => Number(a.sequenceNo) - Number(b.sequenceNo))?.map((itm) => ({
                        label: itm.title,
                        key: itm.uuid,
                        value: itm.uuid,
                        sequenceNo: itm.sequenceNo,
                    })) || []);
                };
            } else if (url === "/admin/v1/display-category/display-category-sequence-detail") {
                const res = await fetch(`${BASE_URL}/admin/v1/display-category/display-category-sequence-detail`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    }
                })
                const getRes = await res.json();
                if (getRes.errorCode === 0) {
                    setData(() => getRes.responsePacket?.slice().sort((a, b) => Number(a.sequenceNo) - Number(b.sequenceNo))?.map((itm) => ({
                        label: itm.title,
                        key: itm.uuid,
                        value: itm.uuid,
                        sequenceNo: itm.sequenceNo,
                    })) || []);
                    setFilterData(() => getRes.responsePacket?.slice().sort((a, b) => Number(a.sequenceNo) - Number(b.sequenceNo))?.map((itm) => ({
                        label: itm.title,
                        key: itm.uuid,
                        value: itm.uuid,
                        sequenceNo: itm.sequenceNo,
                    })) || []);
                }
            }
        } catch (e) {
            console.log(e, "error in list api")
        };
    };

    const [parentCatId, setParentCatId] = useState();
    const [showInput, setShowInput] = useState(false);

    const getSubCat = async (parentCategoryId) => {
        const token = sessionStorage.getItem('tokenKey');
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/category/sub-category-sequence-detail/${parentCategoryId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setData(() => getRes.responsePacket?.slice()?.sort((a, b) => Number(a.sequenceNo) - Number(b.sequenceNo)).map((itm) => ({
                    label: itm.title,
                    key: itm.uuid,
                    value: itm.uuid,
                    sequenceNo: itm.sequenceNo,
                })) || []);
                setFilterData(() => getRes.responsePacket?.slice().sort((a, b) => Number(a.sequenceNo) - Number(b.sequenceNo))?.map((itm) => ({
                    label: itm.title,
                    key: itm.uuid,
                    value: itm.uuid,
                    sequenceNo: itm.sequenceNo,
                })) || []);
            }
        } catch (e) {
            console.log(e, "error in getSub");
        }
    };

    const [subCategory, setSubCategory] = useState([]);
    const parentCatItems = async (id) => {
        try {
            const token = sessionStorage.getItem('tokenKey');
            const res = await fetch(`${BASE_URL}/admin/v1/item/parent-cate-item-seq-detail/${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setData(() => getRes.responsePacket?.slice().sort((a, b) => Number(a.sequenceNo) - Number(b.sequenceNo))?.map((itm) => ({
                    label: itm.title,
                    key: itm.uuid,
                    value: itm.uuid,
                    sequenceNo: itm.sequenceNo,
                })) || []);
                setFilterData(() => getRes.responsePacket?.slice().sort((a, b) => Number(a.sequenceNo) - Number(b.sequenceNo))?.map((itm) => ({
                    label: itm.title,
                    key: itm.uuid,
                    value: itm.uuid,
                    sequenceNo: itm.sequenceNo,
                })) || []);
            }
        } catch (e) {
            console.log(e, "error in subcate");
        }
    };
    const subCat = async (parentCatId) => {
        try {
            const token = sessionStorage.getItem('tokenKey');
            const res = await fetch(`${BASE_URL}/admin/v1/category/sub-category-sequence-detail/${parentCatId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
            const getRes = await res.json();
            if (getRes.errorCode === 0 && getRes.responsePacket?.length > 0) {
                setSubCategory(getRes.responsePacket)
            } else if (getRes.errorCode === 0 && getRes.responsePacket?.length <= 0) {
                parentCatItems(parentCatId);
            }
        } catch (e) {
            console.log(e, "error in subcate items");
        }
    };
    const displayCatItems = async (id) => {
        try {
            const token = sessionStorage.getItem('tokenKey');
            const res = await fetch(`${BASE_URL}/admin/v1/item/parent-cate-item-seq-detail/${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setData(() => getRes.responsePacket?.slice().sort((a, b) => Number(a.sequenceNo) - Number(b.sequenceNo))?.map((itm) => ({
                    label: itm.title,
                    key: itm.uuid,
                    value: itm.uuid,
                    sequenceNo: itm.sequenceNo,
                })) || []);
                setFilterData(() => getRes.responsePacket?.slice().sort((a, b) => Number(a.sequenceNo) - Number(b.sequenceNo))?.map((itm) => ({
                    label: itm.title,
                    key: itm.uuid,
                    value: itm.uuid,
                    sequenceNo: itm.sequenceNo,
                })) || []);
            }
        } catch (e) {
            console.log(e, "error in subcate");
        }
    };

    useEffect(() => {
        if (selectedOption === "Subcategory" && parentCatId) {
            getSubCat(parentCatId);
        } else if (selectedOption === "Items" && parentCatId) {
            subCat(parentCatId);
        } else if (selectedOption === "Display category Items" && parentCatId) {
            displayCatItems(parentCatId);
        }
    }, [parentCatId]);

    const [subCatId, setSubCatId] = useState('');
    const itemSeqList = async (id) => {
        try {
            const token = sessionStorage.getItem('tokenKey');
            const res = await fetch(`${BASE_URL}/admin/v1/item/sub-cate-item-seq-detail/${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setData(() => getRes.responsePacket?.slice().sort((a, b) => Number(a.sequenceNo) - Number(b.sequenceNo))?.map((itm) => ({
                    label: itm.title,
                    key: itm.uuid,
                    value: itm.uuid,
                    sequenceNo: itm.sequenceNo,
                })) || []);
                setFilterData(() => getRes.responsePacket?.slice().sort((a, b) => Number(a.sequenceNo) - Number(b.sequenceNo))?.map((itm) => ({
                    label: itm.title,
                    key: itm.uuid,
                    value: itm.uuid,
                    sequenceNo: itm.sequenceNo,
                })) || []);
            }
        } catch (e) {
            console.log(e, "error in itemseq");
        }
    };

    useEffect(() => {
        if (selectedOption === "Items" && subCatId) {
            itemSeqList(subCatId);
        }
    }, [subCatId]);

    const handleSearchByName = (e) => {
        const get = e.target.value;
        const filter = data.filter((itm) =>
            itm.label.toLowerCase().includes(get.toLowerCase())
        );
        setFilterData(filter);
    };

    const handleSearchBySequence = (e) => {
        const filter = data.filter((itm) =>
            itm.sequenceNo.toString().includes(e.target.value)
        );
        setFilterData(filter);
    };

    const [selectedOption, setSelectedOption] = useState('');
    const [searchOrder, setSearchOrder] = useState('');
    const [searchName, setSearchName] = useState('');

    const moveItem = (fromIndex, toIndex) => {
        setData((prevItems) => {
            const updated = [...prevItems];
            const [moved] = updated.splice(fromIndex, 1);
            updated.splice(toIndex, 0, moved);
            return updated;
        });
        setFilterData((prevItems) => {
            const updated = [...prevItems];
            const [moved] = updated.splice(fromIndex, 1);
            updated.splice(toIndex, 0, moved);
            return updated;
        });
    };

    const [parentList, setParentList] = useState([]);
    const [displayCatOption, setDisplayCatOption] = useState([]);

    const getParentCatList = async (selected) => {
        const token = sessionStorage.getItem('tokenKey');
        try {
            if (selected === "displayItem") {
                const res = await fetch(`${BASE_URL}/admin/v1/display-category/display-category-sequence-detail`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    }
                })
                const getRes = await res.json();
                if (getRes.errorCode === 0) {
                    setDisplayCatOption(getRes.responsePacket);
                }
            } else {
                const res = await fetch(`${BASE_URL}/admin/v1/category/parent-category-sequence-detail`, {
                    // method: "POST",
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                const getRes = await res.json();
                if (getRes.errorCode === 0) {
                    setParentList(getRes.responsePacket);
                }
            }
        } catch (e) {
            console.log(e, "error in getCategory Lis");
        }
    };

    useEffect(() => {
        if (selectedOption === "Category") {
            getList("/admin/v1/category/parent-category-list-in-key-value");
            setParentCatId('');
            setShowInput(false);
            setParentList([]);
            setSubCatId('');
        } else if (selectedOption === "Banner") {
            getList("/admin/v1/banner/list");
            setParentCatId('');
            setShowInput(false);
            setParentList([]);
            setSubCatId('');
        } else if (selectedOption === "Subcategory" && parentList?.length <= 0) {
            setShowInput(true);
            getParentCatList();
            setSubCatId('');
            setParentCatId('');
            setData([]);
            setFilterData([]);
        } else if (selectedOption === "Display Category") {
            getList("/admin/v1/display-category/display-category-sequence-detail");
            setParentCatId('');
            setShowInput(false);
            setParentList([]);
            setSubCatId('');
        } else if (selectedOption === "Items" && parentList?.length <= 0) {
            getParentCatList();
            setShowInput(true);
            setSubCatId('');
            setParentCatId('');
            setData([]);
            setFilterData([]);
            setSubCategory([]);
        } else if (selectedOption === "Display category Items" && displayCatOption?.length <= 0) {
            getParentCatList("displayItem");
            setShowInput(true);
            setSubCatId('');
            setParentCatId('');
            setData([]);
            setFilterData([]);
            setSubCategory([]);
        }
    }, [selectedOption, parentCatId]);

    const postSequence = async () => {
        try {
            const token = sessionStorage.getItem('tokenKey');
            const payload = data.map((item, index) => ({
                id: item.key || item.value,
                sequenceNo: index + 1
            }));
            const res = await fetch(`${BASE_URL}/admin/v1/category/update-Cat-SubCat-Display-Ordering`, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ catSubCatSequences: payload })
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                alert(getRes.message);
                if (selectedOption === "Category") {
                    getList("/admin/v1/category/parent-category-list-in-key-value");
                    setParentCatId('');
                    setShowInput(false);
                    setParentList([]);
                } else if (selectedOption === "Banner") {
                    getList("/admin/v1/banner/list");
                    setParentCatId('');
                    setShowInput(false);
                    setParentList([]);
                } else if (selectedOption === "Subcategory" && parentCatId) {
                    getSubCat(parentCatId);
                } else if (selectedOption === "Display Category") {
                    getList("/admin/v1/display-category/display-category-sequence-detail");
                    setParentCatId('');
                    setShowInput(false);
                    setParentList([]);
                }
            }
        } catch (e) {
            console.log(e, "error in post sequence");
        }
    };

    const postItemSeq = async () => {
        try {
            const payload = data.map((item, index) => ({
                id: item.key || item.value,
                sequenceNo: index + 1
            }));
            const token = sessionStorage.getItem('tokenKey');
            const res = await fetch(`${BASE_URL}/admin/v1/item/update-Item-Ordering`, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    itemSequences: payload
                })
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                alert(getRes.message);
                if (parentCatId && subCatId && subCategory?.length > 0) {
                    itemSeqList(subCatId);
                } else if (parentCatId && subCategory?.length <= 0) {
                    parentCatItems(parentCatId);
                }
            }
        } catch (e) {
            console.log(e, "error in item post seq");
        }
    };

    useEffect(() => {
        const handleAutoScroll = (e) => {
            const scrollSpeed = 20;
            const edgeMargin = 100;
            const y = e.clientY;
            const windowHeight = window.innerHeight;
            if (y < edgeMargin) {
                window.scrollBy(0, -scrollSpeed);
            } else if (y > windowHeight - edgeMargin) {
                window.scrollBy(0, scrollSpeed);
            }
        };

        document.addEventListener("dragover", handleAutoScroll);
        return () => {
            document.removeEventListener("dragover", handleAutoScroll);
        };
    }, []);

    const [sortOrder, setSortOrder] = useState("");

    // Sorting handler
    const handleSort = (order) => {
        setSortOrder(order);
        let sortedData = [...filterData];

        if (order === "asc") {
            sortedData.sort((a, b) => a.label.localeCompare(b.label));
        } else if (order === "desc") {
            sortedData.sort((a, b) => b.label.localeCompare(a.label));
        }

        setData(sortedData);
        setFilterData(sortedData);
    };

    return (
        <>
            <DndProvider backend={HTML5Backend}>
                <div className="category">
                    <div className="row">
                        <div className="category" style={{ display: "block", width: "100%" }}>
                            <div className="category-nav">
                                <div className="category-text">
                                    <h4>Sequence List</h4>
                                </div>
                                <div className="category-btn">
                                    <Link>
                                        <button onClick={() => { (selectedOption === "Items" || selectedOption === "Display category Items") ? postItemSeq() : postSequence() }}>Submit</button>
                                    </Link>
                                </div>
                            </div>
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="reorder-container">
                    <h1 className="reorder-title">Reorder Navigation</h1>
                    <div className="reorder-select-wrapper">
                        <select
                            value={selectedOption}
                            onChange={e => { setSelectedOption(e.target.value); setParentCatId(''); setSubCatId(''); setSubCategory([]) }}
                            className="reorder-select"
                            style={{ margin: 0 }}
                        >
                            <option>Select Module</option>
                            <option value="Category">Category</option>
                            <option value="Display Category">Display Category</option>
                            <option value="Subcategory">Subcategory</option>
                            <option value="Items">Items</option>
                            <option value="Display category Items">Display Category Items</option>
                        </select>
                        {(selectedOption === "Subcategory" || selectedOption === "Items") && showInput && parentList?.length > 0 &&
                            <select
                                value={parentCatId}
                                onChange={e => setParentCatId(e.target.value)}
                                className="reorder-select"
                                style={{ margin: 0 }}
                            >
                                <option hidden>Select Category</option>
                                {
                                    parentList?.slice()?.sort((a, b) => Number(a.sequenceNo) - Number(b.sequenceNo))?.map((item) => {
                                        return (
                                            <option value={item.uuid}>{item.title}</option>
                                        )
                                    })
                                }
                            </select>}
                        {(selectedOption === "Display category Items") && showInput && displayCatOption?.length > 0 &&
                            <select
                                value={parentCatId}
                                onChange={e => setParentCatId(e.target.value)}
                                className="reorder-select"
                                style={{ margin: 0 }}
                            >
                                <option hidden>Select Display Category</option>
                                {
                                    displayCatOption?.slice()?.sort((a, b) => Number(a.sequenceNo) - Number(b.sequenceNo))?.map((item) => {
                                        return (
                                            <option value={item.uuid}>{item.title}</option>
                                        )
                                    })
                                }
                            </select>}
                        <button
                            onClick={() => { setSelectedOption(''); setData([]); setFilterData([]); setParentCatId(''); setSubCatId('');setSortOrder('') }}
                            className="reorder-clear"
                        >
                            ✕
                        </button>
                    </div>

                    {selectedOption === "Items" && showInput && subCategory?.length > 0 && <div className="reorder-select-wrapper">
                        <select name="" id="" className="reorder-select"
                            style={{ margin: 0 }}
                            value={subCatId}
                            onChange={(e) => setSubCatId(e.target.value)}
                        >
                            <option hidden>Select Category</option>
                            {
                                subCategory?.slice()?.sort((a, b) => Number(a.sequenceNo) - Number(b.sequenceNo))?.map((item) => {
                                    return (
                                        <option value={item.uuid}>{item.title}</option>
                                    )
                                })
                            }
                        </select>
                    </div>}

                    <div className="reorder-table-wrapper">
                        <div className="reorder-head-container">
                            <h2 className="reorder-table-title">Sorting Table</h2>
                            {filterData?.length > 0 && <div>
                                <select value={sortOrder} onChange={(e) => handleSort(e.target.value)}>
                                    <option value="" selected disabled>Sort ↑↓</option>
                                    <option value="asc">A-Z</option>
                                    <option value="desc">Z-A</option>
                                </select>
                            </div>}
                        </div>
                        <table className="reorder-table">
                            <thead>
                                <tr>
                                    <th>Sr.No</th>
                                    <th>
                                        <input
                                            type="text"
                                            placeholder="Current Order No"
                                            className="reorder-input"
                                            value={searchOrder}
                                            onChange={e => { setSearchOrder(e.target.value); handleSearchBySequence(e) }}
                                        />
                                    </th>
                                    <th>
                                        <input
                                            type="text"
                                            placeholder="Name"
                                            className="reorder-input"
                                            value={searchName}
                                            onChange={e => { setSearchName(e.target.value); handleSearchByName(e) }}
                                        />
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {filterData.map((item, index) => (
                                    <DraggableItem
                                        key={item.value}
                                        id={item.key}
                                        name={item.label}
                                        index={index}
                                        moveItem={moveItem}
                                        sequence={item.sequenceNo}
                                    />
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </DndProvider >
        </>
    );
};

export default ReorderList;